module.exports = __webpack_public_path__ + "static/img/table-card.432452d9.png";